export const SET_FORM_VALUE = "SET_FORM_VALUE@DATAASSEST"
export const SET_FORM_VALUEOBJ = "SET_FORM_VALUEOBJ@DATAASSEST"
export const SET_ERROR_MESSAGE = "SET_ERROR_MESSAGE@DATAASSEST"
export const CLEAR_ALL_ERROR_MESSAGE = "CLEAR_ALL_ERROR_MESSAGE@DATAASSEST"
export const CLEAR_ERROR_MESSAGE = "CLEAR_ERROR_MESSAGE@DATAASSEST"
export const LOAD_API_DATA="LOAD_API_DATA@DATAASSET"
export const SET_API_DATA = "SET_API_DATA@DATAASSET"
export const SET_FORM_OPTION = "SET_FORM_OPTION@DATAASSET"
export const SET_FORM_OPTION_OBJECT_VALUE = "SET_FORM_OPTION_OBJECT_VALUE@DATAASSET"
export const DATA_ASSET_ACTIVE_TAB = "DATA_ASSET_ACTIVE_TAB@DATAASSET"
export const RESET_FORM_VALUE = "RESET_FORM_VALUE@DATAASSET"
export const SET_DIMENSIONS = "SET_DIMENSIONS@DATAASSET"
export const SET_DIMENSIONS_DATA = "SET_DIMENSIONS_DATA@DATAASSET"
export const SET_FORM_OPTION_OBJECTS_OBJECT_VALUE ="SET_FORM_OPTION_OBJECTS_OBJECT_VALUE@DATAASSET"
export const SET_FORM_OPTIONOBJECTS_OBJECT_VALUE = "SET_FORM_OPTIONOBJECTS_OBJECT_VALUE@DATAASSET"
